import React from 'react';
import {authRole} from '../../shared/constants/AppConst';
//Route config for eRx details
export const audiodigitizationConfig = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/audiodigitization',
        component: React.lazy(() => import('./AudioOpdDigi')),
      },
    ],
  },
];